import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const DeleteConfirmModal = ({ user, onClose, onConfirm }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const handleConfirm = async () => {
    setIsDeleting(true);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      onConfirm();
    } catch (error) {
      console.error('Error deleting user:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const isConfirmValid = confirmText === user.name;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="flex items-center gap-4 p-6 border-b border-secondary-200">
          <div className="w-12 h-12 bg-error-100 rounded-full flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} className="text-error" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-text-primary">
              Подтвердите удаление
            </h2>
            <p className="text-sm text-text-secondary">
              Это действие нельзя отменить
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="p-4 bg-error-50 border border-error-200 rounded-md">
            <div className="flex items-start gap-3">
              <Icon name="AlertCircle" size={20} className="text-error mt-0.5" />
              <div>
                <p className="font-medium text-error mb-1">
                  Внимание! Удаление пользователя
                </p>
                <p className="text-sm text-error-700">
                  Вы собираетесь удалить пользователя <strong>{user.name}</strong>. 
                  Все данные, связанные с этим пользователем, будут безвозвратно удалены.
                </p>
              </div>
            </div>
          </div>

          {/* User Info */}
          <div className="p-4 bg-secondary-50 rounded-md">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <span className="text-sm font-medium text-white">
                  {user.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
              <div>
                <p className="font-medium text-text-primary">{user.name}</p>
                <p className="text-sm text-text-secondary">{user.email}</p>
                <p className="text-sm text-text-secondary">{user.role} • {user.department}</p>
              </div>
            </div>
          </div>

          {/* Confirmation Input */}
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Для подтверждения введите имя пользователя: <span className="font-semibold">{user.name}</span>
            </label>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="
                w-full px-3 py-2 border border-secondary-200 rounded-md
                focus:outline-none focus:ring-2 focus:ring-error/20 focus:border-error
                transition-all duration-150
              "
              placeholder="Введите имя пользователя"
            />
          </div>

          {/* Warning List */}
          <div className="space-y-2">
            <p className="text-sm font-medium text-text-primary">Что будет удалено:</p>
            <ul className="text-sm text-text-secondary space-y-1">
              <li className="flex items-center gap-2">
                <Icon name="Check" size={14} className="text-error" />
                Профиль пользователя и личные данные
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={14} className="text-error" />
                История входов и активности
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={14} className="text-error" />
                Назначенные роли и разрешения
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={14} className="text-error" />
                Связанные сессии и токены
              </li>
            </ul>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-secondary-200">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="
              px-4 py-2 border border-secondary-200 text-text-secondary rounded-md
              hover:bg-secondary-50 disabled:opacity-50 disabled:cursor-not-allowed
              transition-colors duration-150
            "
          >
            Отмена
          </button>
          <button
            onClick={handleConfirm}
            disabled={!isConfirmValid || isDeleting}
            className="
              flex items-center gap-2 px-4 py-2 bg-error text-white rounded-md
              hover:bg-error-600 disabled:opacity-50 disabled:cursor-not-allowed
              transition-colors duration-150 hover-lift
            "
          >
            {isDeleting && (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            )}
            {isDeleting ? 'Удаление...' : 'Удалить пользователя'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;